import { CreateElement } from "vue";
import i18n from "@/i18n";
import _ from "@/boot/lodash";
import { DataModules } from "@/store/modules/data";
import { DefaultFilters as GatewaysFilters } from "@/data/filters/gateways";
import { DefaultSorters as GatewaysSorters } from "@/data/sorters/gateways";
import { LogoSize, LogoType } from "@/data/enums/logos";
import { IImportMappingSource } from "@/models/imports";
import { IGateway, IGatewayProvider } from "@/models/gateways";
import ProductImage from "@/components/app/global/products/productImage.vue";

const getProviderLogoUrl = (provider: IGatewayProvider) => {
  return _.get(
    _.find(provider.logos || [], logo => {
      if (logo.type === LogoType.ICON && logo.size === LogoSize.ONE_X)
        return true;
      return false;
    }),
    "url",
    null
  );
};

const firstLabel = (h: CreateElement, gateway: IGateway) => {
  return h("p", {}, [h("strong", {}, gateway.name)]);
};

const secondLabel = (h: CreateElement, gateway: IGateway) => {
  return h("p", { class: "is-size-8" }, [
    h(
      "span",
      { class: "has-text-grey-light" },
      `${i18n.t("_.id_#", { id: gateway.id })}`
    )
  ]);
};

const media = (h: CreateElement, gateway: IGateway) => {
  const mediaSrc = getProviderLogoUrl(gateway.gateway_provider);
  return mediaSrc
    ? h("u-square-image", { props: { src: mediaSrc } }, [])
    : h(ProductImage, { props: { product: {} } }, []);
};

export const GatewaySource: IImportMappingSource = {
  props: {
    availableFilters: GatewaysFilters,
    availableSorters: GatewaysSorters(),
    usedDataModule: DataModules.GATEWAYS,
    guardFunctionalities: ["list_brand_gateways"],
    storeParams: querySearch => {
      return {
        with: "gateway_provider.logos",
        ...(querySearch ? { "filter[name|like]": `%${querySearch}%` } : {})
      };
    }
  },
  render: {
    id: (gateway: IGateway) => gateway.id,
    firstLabel: (h: CreateElement, gateway: IGateway) => firstLabel(h, gateway),
    secondLabel: (h: CreateElement, gateway: IGateway) =>
      secondLabel(h, gateway),
    media: (h: CreateElement, gateway: IGateway) => media(h, gateway)
  }
};
